<template>
  <div class="personnel-pay">
    <div class="search">
      <div class="search-left">
        <el-select v-model="warehouseId" @change="updateWarehouse" class="gray" placeholder="请选择仓库">
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select v-model="department" clearable class="gray" placeholder="请选择部门">
          <el-option
            v-for="item in departmentList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="gray"
          v-model="date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
        <el-button class="btn-blue" @click="searchData">搜索</el-button>
      </div>
    </div>
    <div class="table">
      <div class="totle-price">
        <p>
          <span>合计(元)：</span>
          <span>{{ totlePrice }}</span>
        </p>
        <el-button class="btn-text" type="text" @click="getTotlePriceRefresh">重新计算</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="员工"></el-table-column>
        <el-table-column prop="baseSalary" label="当日工资(元)">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputBaseSalary(scope.$index, scope.row.baseSalary)"
              v-model="scope.row.baseSalary"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="mealSalary" label="餐补(元)">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputMealSalary(scope.$index, scope.row.mealSalary)"
              v-model="scope.row.mealSalary"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="overSalary" label="加班工资(元)">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputOverSalary(scope.$index, scope.row.overSalary)"
              v-model="scope.row.overSalary"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="descSalary" label="考勤(元)">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputDescSalary(scope.$index, scope.row.descSalary)"
              v-model="scope.row.descSalary"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="actualSalary" label="实际支出(元)"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="updatePersonnelPay(scope.row)">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import { getDecimal, modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import Employee from "models/employee";
import Expenses from "models/expenses";
const employee = new Employee();
const expenses = new Expenses();
export default {
  data() {
    return {
      warehouseId: "",
      department: "",
      date: "",
      searchForm: {
        warehouseId: "",
        department: "",
        date: ""
      },
      departmentList: [],
      warehouseList: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      totlePrice: 0
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('正式工支出')
    this.getWarehouseList();
  },
  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    //获取部门数据
    getCompanyList() {
      if (this.warehouseId) {
        let warehouseId = this.warehouseId;
        employee.getDeptList(warehouseId).then(res => {
          let departmentList = [];
          if (res.success) {
            res.result.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.name;
              departmentList.push(obj);
            });
            this.departmentList = departmentList;
            this.department = "";
          }
        });
      } else {
        this.departmentList = [];
      }
    },
    //修改仓库
    updateWarehouse() {
      this.getCompanyList();
    },
    getTableData() {
      let page = this.currentPage;
      let deptId = this.searchForm.department;
      let date = this.searchForm.date;
      employee.getSalaryList(page, deptId, date).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let tableData = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.employeeId = value.employeeId;
            obj.name = value.name;
            obj.baseSalary = value.baseSalary;
            obj.mealSalary = value.mealSalary;
            obj.overSalary = value.overSalary;
            obj.descSalary = value.descSalary;
            obj.actualSalary = value.actualSalary;
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //搜索
    searchData() {
      if (this.department && this.date) {
        this.currentPage = 1;
        this.searchForm.department = this.department;
        this.searchForm.date = this.date;
        this.getTableData();
        this.getTotlePrice();
      } else {
        this.$message.error("请选择部门和日期");
      }
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    //合计
    getTotlePrice() {
      if (this.department && this.date) {
        let deptId = this.department;
        let date = this.date;
        employee.getSalaryCost(deptId, date).then(res => {
          if (res.success) {
            this.totlePrice = res.result;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("请选择部门和日期");
      }
    },
    //重新计算
    getTotlePriceRefresh() {
      if (this.department && this.date) {
        let deptId = this.department;
        let date = this.date;
        employee.getSalaryRefresh(deptId, date).then(res => {
          if (res.success) {
            this.$message({
              message: "计算成功",
              type: "success",
              duration: 1000
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
              duration: 3000
            });
          }
        });
      } else {
        this.$message.error("请选择部门和日期");
      }
    },
    //保存
    updatePersonnelPay(row) {
      let data = {};
      data.id = row.id;
      data.employeeId = row.employeeId;
      data.date = this.date;
      data.overSalary = Number(row.overSalary);
      data.descSalary = Number(row.descSalary);
      data.baseSalary = Number(row.baseSalary);
      data.mealSalary = Number(row.mealSalary);
      employee.postSalaryModify(data).then(res => {
        if (res.success) {
          this.$message({
            message: "保存成功",
            type: "success",
            duration: 1000
          });
          this.getTableData();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000
          });
        }
      });
    },
    //限制当日工资输入
    inputBaseSalary(index, price) {
      let baseSalary = getDecimal(price);
      this.tableData[index].baseSalary = baseSalary;
    },
    //限制餐补输入
    inputMealSalary(index, price) {
      let mealSalary = getDecimal(price);
      this.tableData[index].mealSalary = mealSalary;
    },
    //限制加班工资输入
    inputOverSalary(index, price) {
      let overSalary = getDecimal(price);
      this.tableData[index].overSalary = overSalary;
    },
    //限制考勤输入
    inputDescSalary(index, price) {
      let descSalary = getDecimal(price);
      this.tableData[index].descSalary = descSalary;
    }
  }
};
</script>
<style lang="scss" scoped>
.personnel-pay {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-select {
      margin-right: 16px;
    }
    .btn-blue {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .totle-price {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .btn-text {
        margin-left: 16px;
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<style lang="scss">
.personnel-pay {
  .table {
    .el-table {
      .el-input {
        width: 110px;
        .el-input__inner {
          height: 24px;
          width: 110px;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
